import { Box, Grid, GridItem, Text } from "@chakra-ui/react";
import { NumericFormInputGroup } from "../../../../../components/Forms";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import { indexToLetter, VALIDATION_PATTERNS } from "../../../helpers";
import { translateSubElementString } from "../../../../../utils";
import { SUB_LEVER_PARAMETERS } from "../../../helpers";

function SubLever({ leverId, baseYear, subLeverId, subLeverName, subLeverIndex, register, errors, watch }) {
  const { t: globalTranslation } = useTranslation("translation");
  const { t } = useTranslation("translation", {
    keyPrefix: "decarbonization.leversParametersModal"
  });

  const formValues = watch();

  const checkIsRequired = useCallback(() => {
    const foundFilledSubLever = Object.keys(formValues).filter(param =>
      param !== `${leverId}${subLeverId}${SUB_LEVER_PARAMETERS.totalCo2Saved}`).find(key => {
      return key.includes(`${leverId}${subLeverId}`) && formValues[key] !== null && formValues[key] !== "";
    });

    return typeof foundFilledSubLever !== "undefined" ? globalTranslation("errors.required") : false;
  }, [leverId, formValues, subLeverId, globalTranslation]);

  const subLeverDependencies = Object.keys(SUB_LEVER_PARAMETERS).map(key => {
    return `${leverId}${subLeverId}${key}`;
  });

  return (
    <Box paddingInline={8}>
      <Text fontSize="lg" marginBottom={3} fontWeight="semibold">
        {`${indexToLetter(subLeverIndex)}. ${subLeverName}`}
      </Text>
      <Grid templateColumns="repeat(15, 1fr)" gap={4}>
        <GridItem colSpan={2}>
          <NumericFormInputGroup
            {...register(`${leverId}${subLeverId}${SUB_LEVER_PARAMETERS.emissionsSaved}`, {
              required: checkIsRequired(),
              pattern: VALIDATION_PATTERNS.DECIMAL_PERCENTAGE,
              deps: subLeverDependencies
            })}
            label={`${t(`parameters.${SUB_LEVER_PARAMETERS.emissionsSaved}`)} ${checkIsRequired() ? "*" : ""}`}
            errors={errors}
            type="number"
            addonText="%"
            title={formValues[`${leverId}${subLeverId}${SUB_LEVER_PARAMETERS.emissionsSaved}`]}
          />
        </GridItem>
        <GridItem colSpan={2}>
          <NumericFormInputGroup
            {...register(`${leverId}${subLeverId}${SUB_LEVER_PARAMETERS.startYear}`, {
              required: checkIsRequired(),
              pattern: VALIDATION_PATTERNS.POSITIVE_INTEGER,
              deps: subLeverDependencies,
              min: checkIsRequired() ? {
                value: Number(baseYear),
                message: t("errorHandling.minStartYearError", { baseYear: baseYear })
              } : null,
              max: checkIsRequired() ? {
                value: Number(formValues[`${leverId}${subLeverId}${SUB_LEVER_PARAMETERS.endYear}`]),
                message: t("errorHandling.maxStartYearError")
              } : null
            })}
            label={`${t(`parameters.${SUB_LEVER_PARAMETERS.startYear}`)} ${checkIsRequired() ? "*" : ""}`}
            errors={errors}
            type="number"
            title={formValues[`${leverId}${subLeverId}${SUB_LEVER_PARAMETERS.startYear}`]}
          />
        </GridItem>
        <GridItem colSpan={2}>
          <NumericFormInputGroup
            {...register(`${leverId}${subLeverId}${SUB_LEVER_PARAMETERS.endYear}`, {
              required: checkIsRequired(),
              pattern: VALIDATION_PATTERNS.POSITIVE_INTEGER,
              deps: subLeverDependencies,
              min: checkIsRequired() ? {
                value: Number(formValues[`${leverId}${subLeverId}${SUB_LEVER_PARAMETERS.startYear}`]),
                message: t("errorHandling.endYearError")
              } : null
            })}
            label={`${t(`parameters.${SUB_LEVER_PARAMETERS.endYear}`)} ${checkIsRequired() ? "*" : ""}`}
            errors={errors}
            type="number"
            title={formValues[`${leverId}${subLeverId}${SUB_LEVER_PARAMETERS.endYear}`]}
          />
        </GridItem>
        <GridItem colSpan={3}>
          <NumericFormInputGroup
            {...register(`${leverId}${subLeverId}${SUB_LEVER_PARAMETERS.initialInvestmentPrice}`, {
              required: checkIsRequired(),
              pattern: VALIDATION_PATTERNS.POSITIVE_NUMBER,
              deps: subLeverDependencies
            })}
            label={`${t(`parameters.${SUB_LEVER_PARAMETERS.initialInvestmentPrice}`)} ${checkIsRequired() ? "*" : ""}`}
            errors={errors}
            type="number"
            addonText="£"
            title={formValues[`${leverId}${subLeverId}${SUB_LEVER_PARAMETERS.initialInvestmentPrice}`]}
          />
        </GridItem>
        <GridItem colSpan={3}>
          <NumericFormInputGroup
            {...register(`${leverId}${subLeverId}${SUB_LEVER_PARAMETERS.operationalCostPerYear}`, {
              required: checkIsRequired(),
              pattern: VALIDATION_PATTERNS.POSITIVE_NUMBER,
              deps: subLeverDependencies
            })}
            label={`${t(`parameters.${SUB_LEVER_PARAMETERS.operationalCostPerYear}`)} ${checkIsRequired() ? "*" : ""}`}
            errors={errors}
            type="number"
            addonText="£"
            title={formValues[`${leverId}${subLeverId}${SUB_LEVER_PARAMETERS.operationalCostPerYear}`]}
          />
        </GridItem>
        <GridItem colSpan={3}>
          <NumericFormInputGroup
            {...register(`${leverId}${subLeverId}${SUB_LEVER_PARAMETERS.totalCo2Saved}`)}
            label={translateSubElementString(
              `decarbonization.leversParametersModal.parameters.${SUB_LEVER_PARAMETERS.totalCo2Saved}`)}
            errors={errors}
            type="number"
            addonText={translateSubElementString(`measures.tCO2e`)}
            disabled={true}
            title={formValues[`${leverId}${subLeverId}${SUB_LEVER_PARAMETERS.totalCo2Saved}`]}
          />
        </GridItem>
      </Grid>
    </Box>
  );
}

export default SubLever;